import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const LanguageIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M6 2a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Zm5.99 2H2a1 1 0 0 0 0 2h8.13l-.9 1.36L7.5 9.1 5.7 7.3a1 1 0 0 0-1.4 1.42l1.79 1.79-2.8 2.8a1 1 0 1 0 1.42 1.4l2.79-2.79 2.8 2.8a1 1 0 0 0 1.4-1.42l-2.78-2.8 1.8-1.8a1 1 0 0 0 .12-.15L12.53 6H14a1 1 0 1 0 0-2h-2.01ZM17 11a1 1 0 0 1 .9.55l2.99 5.98a1 1 0 0 1 .01.04l2 3.98a1 1 0 1 1-1.8.9L19.39 19h-4.76l-1.73 3.45a1 1 0 1 1-1.78-.9l1.99-3.98a1 1 0 0 1 .01-.04l3-5.98A1 1 0 0 1 17 11Zm-1.38 6h2.76L17 14.24 15.62 17Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default LanguageIcon;
